var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-container hide-xs"
  }, [_c('div', {
    staticClass: "top-header row"
  }), _c('header', {
    staticClass: "row"
  }, [_vm._m(0), _c('div', {
    staticClass: "nav-container",
    class: {
      expanded: _vm.menuExpanded
    }
  }, [_c('nav', {
    staticClass: "main-nav"
  }, [_c('li', [_c('a', {
    staticClass: "nav-button btn-spy",
    attrs: {
      "href": "#slide"
    },
    on: {
      "click": _vm.changeMenu
    }
  }, [_vm._v("Inicio")])]), _c('li', [_c('a', {
    staticClass: "nav-button btn-spy",
    attrs: {
      "href": "#beneficios"
    },
    on: {
      "click": _vm.changeMenu
    }
  }, [_vm._v("Beneficios")])]), _c('li', [_c('a', {
    staticClass: "nav-button btn-spy",
    attrs: {
      "href": "#servicios"
    },
    on: {
      "click": _vm.changeMenu
    }
  }, [_vm._v("Servicios")])]), _c('li', [_c('a', {
    staticClass: "nav-button btn-spy",
    attrs: {
      "href": "#noticias"
    },
    on: {
      "click": _vm.changeMenu
    }
  }, [_vm._v("Noticias")])]), _c('li', [_c('a', {
    staticClass: "nav-button special btn-spy",
    attrs: {
      "href": "#contacto"
    },
    on: {
      "click": _vm.changeMenu
    }
  }, [_vm._v("Contacto")])])])]), _c('div', {
    staticClass: "hamburger-menu",
    on: {
      "click": _vm.changeMenu
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("menu")])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "brand-name"
  }, [_c('img', {
    staticClass: "responsive-img",
    attrs: {
      "src": require("./../assets/img/logo.svg")
    }
  }), _c('div', {
    staticClass: "logo-box"
  }, [_c('h1', {
    staticClass: "name"
  }, [_vm._v("IC Services")]), _c('small', {
    staticClass: "statement"
  }, [_vm._v("La red que te conecta con los tuyos")])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-df1747c4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/src/components/HomeHeader.vue
// module id = 50
// module chunks = 0